import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Tune,
} from "@material-ui/icons";
import { Autocomplete } from "@mui/material";
import { TextField } from "@material-ui/core";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import React, { useState, useRef, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Col, Row, Modal, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getContactsActions,
  getUserRolesAction,
} from "../../actions/UserActions";
import {
  getAllCalendarEventsAction,
  getTransactionDataAction,
  deleteTaskAction,
  getAllTasksAction,
  getAllTasksActionwithResptTocontingecies,
  getAllTransactionsAction,
  getAllTransactionsActionNew,
  getAllTasksActionByOwnerID,
} from "./../../actions/TransactionActions";
import {
  getVendorTransactionsAction,
  getVendorTransactionsActionNew,
} from "./../../actions/VendorTransactionActions";
import "./../../assets/scss/plugins/_plugin-react-big-calendar.scss";
import TaskDetail from "./../Transactions/Detail/task-detail";
import { cryptoTokenDecode, getTimeFromMins } from "./../Common/Common";
import TransactionPrompt from "../Common/TransactionPrompt";
import Select from "react-select";
import * as message from "../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
var CryptoJS = require("crypto-js");

const localizer = momentLocalizer(moment);

class CalendarModule extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    let userId = localStorage.getItem("ID");
    this.setStartDate = this.setStartDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    this.state = {
      events: [],
      allEvents: [],
      alert: null,
      addTask: "",
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),
      viewTask: false,
      viewState: "month",
      taskId: "",
      transactionData: {},
      showLoader: false,
      defaultView: "month",
      defaultDate: new Date(),
      showTransactionPrompt: false,
      artistId: "",
      contacts: [],
      selectedArtist: "",
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      userId: userId,
      vendorTransactions: [],
      ownerId: "",
      toggleFilter: false,
      permissionArray: [],
      CalendarDate: new Date(),
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.formats = {
      eventTimeRangeFormat: (e) => {
        return moment(e.start).format("h:mm A");
      },
    };
  }

  getUserPermissions() {
    if (this.state.userType === "VENDOR") {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        permissionarray = decryptedData.split(",");
        this.setState({ permissionArray: permissionarray });
      }
    }
  }

  checkPermission(checkFor) {
    if (this.state.userType === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        this.state.permissionArray &&
        this.state.permissionArray.length > 0 &&
        checkFor.some((item) => this.state.permissionArray.includes(item));
      return hasSome;
    }
  }

  setStartDate(event, picker) {
    this.setState({
      startDate: picker.startDate,
    });
  }

  setEndDate(event, picker) {
    this.setState({
      closeDate: picker.startDate,
    });
  }

  toggleTask = (i) => {
    if (i == 0) {
      this.setState({ addTask: "open" });
    } else {
      this.setState({ addTask: "" });
    }
  };

  handleToggleFilter() {
    this.setState({ toggleFilter: !this.state.toggleFilter });
  }

  // view task modal
  selectedEvent(event) {
    this.setState({ viewTask: false });
    this.props.getTransactionDataAction(event.transactionId).then((res) => {
      if (res) {
        this.setState({
          viewTask: true,
          transactionData: res,
          taskId: event._id,
        });
      }
    });
  }

  getAllContacts() {
    let rolename = "admin";
    if (this.state.userType === message.VENDOR) {
      rolename = "ep";
      this.props
        .getContactsActions(
          rolename,
          "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
        )
        .then((res) => {
          this.props.getUserRolesAction(
            "?id=" + localStorage.getItem("ownerId")
          );
          this.setState({
            contacts: this.props.contacts || [],
          });
          // this.loadCalendarEvents();
          this.loadCalendarEventsNew("month", "", new Date());
        });
    } else {
      this.props.getContactsActions().then((res) => {
        this.props.getUserRolesAction();
        this.setState({
          contacts: this.props.contacts || [],
          showLoader: false,
        });
        // this.loadCalendarEvents();
        this.loadCalendarEventsNew("month", "", new Date());
      });
    }
  }

  loadCalendarEvents() {
    if (this.state.allEvents.length === 0) {
      var eventsAPI = [];
      let transIds = [];
      this.props.getAllTransactionsActionNew().then((transRes) => {
        this.props.getVendorTransactionsActionNew().then((vendorRes) => {
          let allTransactions = this.props.transactions.data || [];
          let vendorTransactions =
            (this.props.vendorTransactions &&
              this.props.vendorTransactions.data) ||
            [];
          if (
            this.state.userType === message.VENDOR &&
            !this.checkPermission([
              message.manage_appointments,
              message.view_appointments,
            ])
          ) {
            for (let x = 0; x < vendorTransactions.length; x++) {
              let vendorIds = [];
              vendorIds = vendorTransactions[x]._id;
              transIds.push(vendorIds);
            }
          } else {
            for (let y = 0; y < allTransactions.length; y++) {
              let allIds = [];
              allIds = allTransactions[y]._id;
              transIds.push(allIds);
            }
          }
          if (transIds.length > 0) {
            for (let k = 0; k < transIds.length; k++) {
              this.props
                .getAllTasksActionwithResptTocontingecies(transIds[k], "Client")
                .then(
                  (res) => {
                    let eventsRes = res.data.data;

                    if (res) {
                      eventsRes.forEach((e) => {
                        if (
                          e.specialTask.length > 0 &&
                          e.specialTask[0] === "Appointment" &&
                          e.status !== "CANCELED"
                        ) {
                          e.eventEndDate = new Date(
                            moment(e.eventEndDate).format("MM/DD/YYYY ") +
                              moment(e.eventEndDate).get("hour") +
                              ":" +
                              moment(e.eventEndDate).get("minutes")
                          );
                          e.eventStartDate = new Date(
                            moment(e.eventStartDate).format("MM/DD/YYYY ") +
                              moment(e.eventStartDate).get("hour") +
                              ":" +
                              moment(e.eventStartDate).get("minutes")
                          );
                          let assigneeName = "";
                          let clientName = "";
                          let assigneeColor = "";

                          if (e.ClientNameBE) {
                            clientName = e.ClientNameBE;
                          }

                          if (e.assigneeNameBE) {
                            assigneeName = e.assigneeNameBE;
                          }

                          if (e.assigneeColorBE) {
                            assigneeColor = e.assigneeColorBE;
                          }

                          // for (let i = 0; i < this.state.contacts.length; i++) {
                          //   if (
                          //     e.communicationToUserId[0] ===
                          //     this.state.contacts[i].contactId
                          //   ) {
                          //     assigneeName =
                          //       this.state.contacts[i].firstname +
                          //       (this.state.contacts[i].lastname
                          //         ? " " + this.state.contacts[i].lastname
                          //         : "");
                          //     assigneeColor = this.state.contacts[i].color;
                          //   }

                          //   if (
                          //     e.clientId === this.state.contacts[i].contactId
                          //   ) {
                          //     clientName =
                          //       this.state.contacts[i].firstname +
                          //       (this.state.contacts[i].lastname
                          //         ? " " + this.state.contacts[i].lastname
                          //         : "");
                          //   }
                          // }
                          if (
                            (this.state.userType === message.VENDOR ||
                              this.state.userType === message.ACCTOWNER ||
                              this.state.currentRole === message.ACCTOWNER) &&
                            e.communicationToUserId[0] ===
                              localStorage.getItem("ID")
                          ) {
                            assigneeName =
                              localStorage.getItem("fname") +
                              (localStorage.getItem("lname")
                                ? " " + localStorage.getItem("lname")
                                : "");
                            assigneeColor = "";
                          }
                          eventsAPI.push({
                            title: e.title,
                            assignee: assigneeName ? assigneeName : e.title,
                            assigneeId: e.communicationToUserId[0],
                            allDay: false,
                            start: new Date(
                              moment(e.eventStartDate).get("year"),
                              moment(e.eventStartDate).get("month"),
                              moment(e.eventStartDate).get("date"),
                              moment(e.eventStartDate).get("hour"),
                              moment(e.eventStartDate).get("minutes")
                            ),
                            end: new Date(
                              moment(e.eventEndDate).get("year"),
                              moment(e.eventEndDate).get("month"),
                              moment(e.eventEndDate).get("date"),
                              moment(e.eventEndDate).get("hour"),
                              moment(e.eventEndDate).get("minutes")
                            ),
                            color: assigneeColor,
                            _id: e._id,
                            transactionId: e.transactionId,
                            clientName: clientName,
                            time: e.time,
                          });
                        }
                      });

                      this.setState({
                        allEvents: eventsAPI,
                        showLoader: false,
                      });

                      this.setState({
                        events: this.filterEvents(eventsAPI, "all"),
                      });
                    }
                  },
                  (error) => {
                    this.setState({
                      showLoader: false,
                    });
                  }
                );
            }
          } else {
            this.setState({
              showLoader: false,
            });
          }
        });
      });
    }
  }

  filterEvents(eventsAPI, artistName) {
    if (artistName !== undefined && artistName === "all") {
      return eventsAPI;
    } else {
      let filteredEvents = [];
      eventsAPI.forEach((event) => {
        if (event.assignee === artistName) {
          filteredEvents.push({
            title: event.title,
            assignee: event.assignee,
            assigneeId: event.assigneeId,
            allDay: false,
            start: new Date(
              moment(event.start).get("year"),
              moment(event.start).get("month"),
              moment(event.start).get("date"),
              moment(event.start).get("hour"),
              moment(event.start).get("minutes")
            ),
            end: new Date(
              moment(event.end).get("year"),
              moment(event.end).get("month"),
              moment(event.end).get("date"),
              moment(event.end).get("hour"),
              moment(event.end).get("minutes")
            ),
            color: event.color,
            _id: event._id,
            transactionId: event.transactionId,
            clientName: event.clientName,
            time: event.time,
          });
        }
      });
      return filteredEvents;
    }
  }

  handleArtistSelection(e) {
    let artistEvents = this.state.allEvents;
    if (e) {
      let selectedArtistName = e.firstname + " " + e.lastname;
      this.setState({
        events: this.filterEvents(artistEvents, selectedArtistName),
        selectedArtist: selectedArtistName,
      });
    } else {
      this.setState({
        events: this.filterEvents(artistEvents, "all"),
        selectedArtist: "",
      });
    }
  }

  addNewEventAlert(slotInfo) {
    this.toggleTask(0);
  }

  /**
   * @desc add new event to calendar
   */
  addNewEvent(e, slotInfo) {
    var newEvents = this.state.events;
    newEvents.push({
      title: e,
      start: slotInfo.start,
      end: slotInfo.end,
    });
    this.setState({
      alert: null,
      events: newEvents,
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  deleteTask(id) {
    this.setState({ viewTask: false });
    this.props.deleteTaskAction(id).then((res) => {
      // this.loadCalendarEvents();
      this.loadCalendarEventsNew("month", "", this.state.CalendarDate);
    });
  }

  eventColors(event, start, end, isSelected) {
    var backgroundColor = "event-";
    if (event.color) {
      return {
        style: {
          backgroundColor: event.color,
          "--my-color-var": event.color,
        },
        className: "with-assignee",
      };
    } else {
      backgroundColor = backgroundColor + "default";
      return {
        className: backgroundColor,
      };
    }
  }

  handleTransactionPrompt() {
    this.setState({ showTransactionPrompt: true });
  }

  componentWillMount() {
    this.setState({ showLoader: true });
    this.getUserPermissions();
    //check if timestamp attached with params then load that data to calendar
    let dateParam = this.props.match.params.date;
    if (dateParam !== undefined) {
      dateParam = parseInt(dateParam);
      let date =
        new Date(dateParam) != "Invalid Date"
          ? new Date(dateParam)
          : new Date();
      this.setState({
        defaultView: "day",
        viewState: "day",
        defaultDate: date,
      });
    }
    // this.getAllContacts();
    this.loadCalendarEventsNew("month", "", new Date());
  }

  /**
   * @desc change view of calendar
   */
  changeView(view, toolbar) {
    toolbar.onView(view);
    this.setState({ viewState: view });
    this.loadCalendarEventsNew("month", "", this.state.CalendarDate);
  }

  checkTransactionsEmpty() {
    if (this.state.userType === message.ACCTOWNER) {
      if (this.props.transactions && this.props.transactions.data.length <= 0) {
        // if no transaction then don't show create appointment button
        return true;
      } else {
        return false;
      }
    } else if (this.state.userType === message.VENDOR) {
      if (localStorage.getItem("vendorRoleName") === "Artist") {
        if (
          this.props.vendorTransactions &&
          this.props.vendorTransactions.data.length <= 0
        ) {
          // if no transaction then don't show create appointment button
          return true;
        } else {
          return false;
        }
      } else {
        // if client then don't show button
        return true;
      }
    }
  }

  loadCalendarEventsNew(view, lable, barDate) {
    let eventsAPI = [];
    let dayflag = true;
    let payloadStartDate = this.state.filterStartDate;
    let payloadEndDate = this.state.filterEndDate;
    if (view === "month") {
      payloadStartDate = new Date(barDate.getFullYear(), barDate.getMonth(), 1);
      payloadEndDate = new Date(
        barDate.getFullYear(),
        barDate.getMonth() + 1,
        0
      );
    } else if (view === "week") {
      // Example usage:
      const inputRange1 = lable;

      const year = barDate.getFullYear();
      const result1 = this.convertDateRange(inputRange1, year);
      // Output: "February 25 – March 02" "25-02-2024" "02-03-2024"
      payloadStartDate = new Date(result1.startDate);
      payloadEndDate = new Date(result1.endDate);
    } else if (view === "day") {
      let barMonth = barDate.getMonth();
      let todayMonth = new Date().getMonth();
      let CalendarDatemonth = new Date(this.state.CalendarDate).getMonth();
      if (barMonth !== todayMonth || barMonth !== CalendarDatemonth) {
        payloadStartDate = new Date(
          barDate.getFullYear(),
          barDate.getMonth(),
          1
        );
        payloadEndDate = new Date(
          barDate.getFullYear(),
          barDate.getMonth() + 1,
          0
        );
      } else {
        dayflag = false;
      }
    }
    if (dayflag) {
      this.setState({
        showLoader: true,
      });
      let ownerId;
      if (this.state.userType === message.VENDOR) {
        ownerId = localStorage.getItem("ownerId");
      } else {
        ownerId = this.state.userId;
      }

      this.props
        .getAllTasksActionByOwnerID(
          ownerId,
          payloadStartDate,
          payloadEndDate,
          message.CLIENT
        )
        .then((res) => {
          let eventsRes = res.data.data;
          if (res) {
            eventsRes.forEach((e) => {
              if (
                e.specialTask.length > 0 &&
                e.specialTask[0] === "Appointment" &&
                e.status !== "CANCELED"
              ) {
                e.eventEndDate = new Date(
                  moment(e.eventEndDate).format("MM/DD/YYYY ") +
                    moment(e.eventEndDate).get("hour") +
                    ":" +
                    moment(e.eventEndDate).get("minutes")
                );
                e.eventStartDate = new Date(
                  moment(e.eventStartDate).format("MM/DD/YYYY ") +
                    moment(e.eventStartDate).get("hour") +
                    ":" +
                    moment(e.eventStartDate).get("minutes")
                );
                let assigneeName = "";
                let clientName = "";
                let assigneeColor = "";

                if (e.ClientNameBE) {
                  clientName = e.ClientNameBE;
                }

                if (e.assigneeNameBE) {
                  assigneeName = e.assigneeNameBE;
                }

                if (e.assigneeColorBE) {
                  assigneeColor = e.assigneeColorBE;
                }
                // for (let i = 0; i < this.state.contacts.length; i++) {
                //   if (
                //     String(e.communicationToUserId[0]) ===
                //     String(this.state.contacts[i].contactId)
                //   ) {
                //     console.log(
                //       "this.state.contacts[i].contactId",
                //       this.state.contacts[i].contactId
                //     );
                //     assigneeName =
                //       this.state.contacts[i].firstname +
                //       (this.state.contacts[i].lastname
                //         ? " " + this.state.contacts[i].lastname
                //         : "");

                //     assigneeColor = this.state.contacts[i].color;
                //   }
                //   if (e.clientId === this.state.contacts[i].contactId) {
                //     clientName =
                //       this.state.contacts[i].firstname +
                //       (this.state.contacts[i].lastname
                //         ? " " + this.state.contacts[i].lastname
                //         : "");
                //   }
                // }
                if (
                  (this.state.userType === message.VENDOR ||
                    this.state.userType === message.ACCTOWNER ||
                    this.state.currentRole === message.ACCTOWNER) &&
                  e.communicationToUserId[0] === localStorage.getItem("ID")
                ) {
                  assigneeName =
                    localStorage.getItem("fname") +
                    (localStorage.getItem("lname")
                      ? " " + localStorage.getItem("lname")
                      : "");
                  assigneeColor = "";
                }
                // console.log("e.title - 614", e.title);
                eventsAPI.push({
                  title: e.title,
                  assignee: assigneeName ? assigneeName : e.title,
                  assigneeId: e.communicationToUserId[0],
                  allDay: false,
                  start: new Date(
                    moment(e.eventStartDate).get("year"),
                    moment(e.eventStartDate).get("month"),
                    moment(e.eventStartDate).get("date"),
                    moment(e.eventStartDate).get("hour"),
                    moment(e.eventStartDate).get("minutes")
                  ),
                  end: new Date(
                    moment(e.eventEndDate).get("year"),
                    moment(e.eventEndDate).get("month"),
                    moment(e.eventEndDate).get("date"),
                    moment(e.eventEndDate).get("hour"),
                    moment(e.eventEndDate).get("minutes")
                  ),
                  color: assigneeColor,
                  _id: e._id,
                  transactionId: e.transactionId,
                  clientName: clientName,
                  time: e.time,
                });
              }
            });
            this.setState({
              allEvents: eventsAPI,
              showLoader: false,
              CalendarDate: barDate,
            });

            this.setState({
              events: this.filterEvents(eventsAPI, "all"),
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }

  convertDateRange(inputRange, year) {
    let splitStrings = inputRange.split(" – ");

    let string1 = splitStrings[0];
    let string2 = splitStrings[1];

    let splitStrings1 = string1.split(" ");

    let startMonth = splitStrings1[0];
    let startDay = splitStrings1[1];

    let splitStrings2 = string2.split(" ");
    let endMonth;
    let endDay;
    if (splitStrings2.length === 1) {
      endMonth = startMonth;
      endDay = splitStrings2[0];
    } else {
      endMonth = splitStrings2[0];
      endDay = splitStrings2[1];
    }
    // Convert month names to month indices (January is 0, February is 1, etc.)
    const monthIndex = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };

    // // Create Date objects for the start and end dates
    const startDateObject = new Date(
      year,
      monthIndex[startMonth],
      parseInt(startDay)
    );
    const endDateObject = new Date(
      year,
      monthIndex[endMonth],
      parseInt(endDay)
    );

    return {
      inputRange,
      startDate: startDateObject,
      endDate: endDateObject,
    };
  }

  CustomToolbar = (toolbar) => {
    const [render, setRender] = useState(false);
    const isFirstRender = useRef(true);
    useEffect(() => {
      // this.loadCalendarEventsNew(toolbar.view, toolbar.label, toolbar.date);
      if (isFirstRender.current) {
        // If it's the initial render, set isFirstRender to false
        isFirstRender.current = false;
      } else {
        // If it's not the initial render, execute your update logic
        this.loadCalendarEventsNew(toolbar.view, toolbar.label, toolbar.date);
      }
    }, [render]);
    const goToBack = () => {
      toolbar.onNavigate("PREV");
      setRender(!render);
    };

    const goToNext = () => {
      toolbar.onNavigate("NEXT");
      setRender(!render);
    };

    const goToCurrent = () => {
      toolbar.onNavigate("TODAY");
      setRender(!render);
    };

    const label = () => {
      return <span>{toolbar.label}</span>;
    };

    return (
      <div className="rbc-calendar">
        <div className="rbc-toolbar d-block">
          <Row className="justify-content-between align-items-center">
            <Col xs={12} sm={4}>
              <span className="rbc-btn-group d-flex">
                <button type="button" onClick={goToCurrent}>
                  Today
                </button>
              </span>
            </Col>
            <Col xs={12} sm={4} className="px-0">
              <span className="rbc-toolbar-label">
                <button type="button" onClick={goToBack}>
                  <KeyboardArrowLeft />
                </button>
                {label()}
                <button type="button" onClick={goToNext}>
                  <KeyboardArrowRight />
                </button>
              </span>
            </Col>
            <Col xs={12} sm={4} align="right">
              <span className="rbc-btn-group cal-view">
                <button
                  type="button"
                  className={
                    this.state.viewState === "day" ? "rbc-active" : undefined
                  }
                  onClick={() => this.changeView("day", toolbar)}
                >
                  Day
                </button>
                <button
                  type="button"
                  className={
                    this.state.viewState === "week" ? "rbc-active" : undefined
                  }
                  onClick={() => this.changeView("week", toolbar)}
                >
                  Week
                </button>
                <button
                  type="button"
                  className={
                    this.state.viewState === "month" ? "rbc-active" : undefined
                  }
                  onClick={() => this.changeView("month", toolbar)}
                >
                  Month
                </button>
              </span>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  render() {
    let contacts = this.state.contacts;
    let listedContacts = [];

    for (let i = 0; i < contacts.length; i++) {
      listedContacts.push({
        label: contacts[i].firstname + " " + contacts[i].lastname,
        id: contacts[i]._id,
        role: contacts[i].roles,
        firstname: contacts[i].firstname,
        lastname: contacts[i].lastname,
        mobileNumber: contacts[i].mobileNumber,
        email: contacts[i].email,
        color: contacts[i].color,
      });
    }

    // if (this.state.userType === message.VENDOR) {
    listedContacts = listedContacts.filter((contactVar) => {
      return contactVar.role === "Artist" || contactVar.role === "ACCTOWNER";
    });
    //}

    return (
      <>
        <div className="calendar-page">
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
            <Col xs="12" sm="4">
              <h4 className="title-med mt-0 pt-1">Appointments</h4>
            </Col>
            <Col className="col-auto" align="right">
              <Form inline className="justify-content-end">
                <Row className="trans-listing-head-row">
                  {this.checkPermission([
                    message.manage_appointments,
                    message.view_appointments,
                  ]) ? (
                    <>
                      <Col className="col-auto pl-0 d-flex trans-listing-head-dropdown">
                        <Autocomplete
                          value={
                            this.state.selectedArtist
                              ? this.state.selectedArtist
                              : ""
                          }
                          onChange={(e, artist) =>
                            this.handleArtistSelection(artist)
                          }
                          // options={listedContacts.filter(
                          //   (contact) => contact.role === "Artist"
                          // )}
                          options={listedContacts}
                          renderInput={(params) => (
                            <TextField {...params} label="Filter by Artist" />
                          )}
                          sx={{ width: "200px" }}
                        />
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                  <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                    {!this.checkTransactionsEmpty() && (
                      <>
                        <Form.Group>
                          <Button
                            variant="primary"
                            className="btn btn-primary btn-blue btn-head w-140 mr-2"
                            style={{ padding: "4px" }}
                            onClick={() => this.handleTransactionPrompt()}
                          >
                            Create Appointment/Artwork
                          </Button>
                        </Form.Group>
                      </>
                    )}
                    {this.checkPermission([
                      message.manage_quick_appointment,
                    ]) && (
                      <>
                        <Form.Group>
                          <Button
                            variant="primary"
                            className="btn btn-primary btn-blue btn-head w-140 mr-2"
                            style={{ padding: "4px" }}
                            onClick={() => {
                              this.props.history.push({
                                pathname: "/quickAppointment",
                              });
                            }}
                          >
                            Create Quick Appointment
                          </Button>
                        </Form.Group>
                      </>
                    )}
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>

          {this.state.showLoader ? (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="admin-content-area mt-10">
            {/* calendar */}
            <Calendar
              views={["day", "week", "month"]}
              localizer={localizer}
              selectable
              components={{
                toolbar: this.CustomToolbar,
              }}
              events={this.state.events}
              defaultView={this.state.defaultView === "day" ? "day" : "month"}
              scrollToTime={new Date(1970, 1, 1, 6)}
              defaultDate={
                this.state.defaultView === "day"
                  ? this.state.defaultDate
                  : new Date()
              }
              onSelectEvent={(event) => this.selectedEvent(event)}
              onSelectSlot={(slotInfo) => this.addNewEventAlert(slotInfo)}
              formats={this.formats}
              tooltipAccessor={(e) => {
                return e.title + " of " + e.clientName + " with " + e.assignee;
              }}
              titleAccessor={(e) => {
                return (
                  getTimeFromMins(e.time) +
                  " " +
                  e.assignee +
                  " , " +
                  e.clientName
                );
              }}
              eventPropGetter={this.eventColors}
            />

            {/* View task slide */}
            {window.innerWidth > 991 ? (
              <div
                className={
                  (this.state.viewTask && "open") +
                  " calendar-add-task task-single cal-task-slide"
                }
              >
                {this.state.viewTask && (
                  <TaskDetail
                    taskId={this.state.taskId}
                    deleteTask={(id) => {
                      this.deleteTask(id);
                    }}
                    onUpdate={(e) => {
                      // this.loadCalendarEvents();
                      this.loadCalendarEventsNew(
                        "month",
                        "",
                        this.state.CalendarDate
                      );
                    }}
                    transactionData={this.state.transactionData}
                    fromTimeline={true}
                    closeDetailsModal={() => {
                      this.setState({ viewTask: false });
                    }}
                    fromAppoCalendar={true}
                    permissiontype={message.manage_appointments}
                  />
                )}
              </div>
            ) : (
              <Modal
                show={this.state.viewTask}
                onHide={() => {
                  this.setState({ viewTask: false });
                }}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                className="modal-med modal-view-page task-mobile-modal"
              >
                <Modal.Header closeButton />
                <Modal.Body>
                  {this.state.viewTask && (
                    <TaskDetail
                      taskId={this.state.taskId}
                      deleteTask={(id) => {
                        this.deleteTask(id);
                      }}
                      onUpdate={(e) => {
                        // this.loadCalendarEvents();
                        this.loadCalendarEventsNew(
                          "month",
                          "",
                          this.state.CalendarDate
                        );
                      }}
                      transactionData={this.state.transactionData}
                      fromTimeline={true}
                      closeDetailsModal={() => {
                        this.setState({ viewTask: false });
                      }}
                      permissiontype={message.manage_appointments}
                    />
                  )}
                </Modal.Body>
              </Modal>
            )}

            {/* Transaction Choice Modal */}
            <TransactionPrompt
              showTransactionPrompt={this.state.showTransactionPrompt}
              cancel={() => {
                this.setState({ showTransactionPrompt: false });
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    taskData: state.reducer.taskData,
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    vendorTransactions: state.reducer.vendorTransactions,
    transactions: state.reducer.transactions,
    tasks: state.reducer.tasks,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllCalendarEventsAction,
    getTransactionDataAction,
    deleteTaskAction,
    getContactsActions,
    getUserRolesAction,
    getAllTransactionsAction,
    getVendorTransactionsAction,
    getAllTasksAction,
    getAllTasksActionwithResptTocontingecies,
    getAllTransactionsActionNew,
    getVendorTransactionsActionNew,
    getAllTasksActionByOwnerID,
  }
)(CalendarModule);
